import { render } from "./RedSquareTrash.vue?vue&type=template&id=4a98cb50"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/RedSquareTrash.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a98cb50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a98cb50', __exports__)) {
    api.reload('4a98cb50', __exports__)
  }
  
  module.hot.accept("./RedSquareTrash.vue?vue&type=template&id=4a98cb50", () => {
    api.rerender('4a98cb50', render)
  })

}


export default __exports__